import { Component, Input, Output, EventEmitter } from '@angular/core';
import { faMapMarker, faGlobe, faPhone, faClock } from '@fortawesome/free-solid-svg-icons';
import { Product } from '../../models/Product';

@Component({
  selector: 'app-plant-list',
  templateUrl: './plant-list.component.html',
  styleUrls: ['./plant-list.component.scss']
})

export class PlantListComponent {
  @Input() plants: Product[] = [];
  @Input() pagination: any;
  @Output() pageChange = new EventEmitter<number>();
  @Output() perPageChange = new EventEmitter<number>();

  sourcesShown: { [plantId: number]: boolean } = {};

  faMapMarker = faMapMarker;
  faGlobe = faGlobe;
  faPhone = faPhone;
  faClock = faClock;

  toggleSources(plantId: number) {
    this.sourcesShown[plantId] = !this.sourcesShown[plantId];
  }
}
